module.exports = __webpack_public_path__ + "6ce1e32387683534f76f5331e8f12a53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_10.jpg
// module id = 1692
// module chunks = 5